import { render, staticRenderFns } from "./areaCompanyList.vue?vue&type=template&id=332ec634&scoped=true&"
import script from "./areaCompanyList.vue?vue&type=script&lang=js&"
export * from "./areaCompanyList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "332ec634",
  null
  
)

export default component.exports